import { render, staticRenderFns } from "./psrview.vue?vue&type=template&id=f27574ee&scoped=true&"
import script from "./psrview.vue?vue&type=script&lang=js&"
export * from "./psrview.vue?vue&type=script&lang=js&"
import style0 from "./psrview.vue?vue&type=style&index=0&id=f27574ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27574ee",
  null
  
)

export default component.exports